module.exports = __webpack_public_path__ + "static/img/20020 (5).7c2b688.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20020 (5).webp
// module id = GNGt
// module chunks = 14